const getEnvironmentVariables = () => {
    if (window.location.host.includes('localhost') || window.location.host.includes("127.0.0.1")) {
        return {
            REACT_APP_CENTRAL_AUTH: "http://localhost:6001",
            REACT_APP_REST_API: "http://localhost:9002",
            REACT_APP_KEYCLOAK_URL: "https://sso-staging.ocelotlinks.com",
            REACT_APP_KEYCLOAK_REALM: "OcelotLinks",
            REACT_APP_KEYCLOAK_CLIENTID: "myclient",
            REACT_APP_ENVIRONMENT : "local",
            REACT_APP_FARO_URL: "",
            REACT_APP_FARO_APP_NAME: "transmission",
            REACT_APP_FARO_SAMPLE_RATE: "1",
            REACT_APP_OCELOTLINK : "http://localhost:5001/"
        };
    } else if (window.location.host.includes('transmission-staging.ocelotlinks.com')) {
        return {
            REACT_APP_CENTRAL_AUTH: "https://central-auth-staging.ocelotlinks.com",
            REACT_APP_REST_API: "https://api-staging.ocelotlinks.com",
            REACT_APP_KEYCLOAK_URL: "https://sso-staging.ocelotlinks.com",
            REACT_APP_KEYCLOAK_REALM: "OcelotLinks",
            REACT_APP_KEYCLOAK_CLIENTID: "myclient",
            REACT_APP_ENVIRONMENT : "staging",
            REACT_APP_FARO_URL: "https://faro.ocelotlinks.com/collect",
            REACT_APP_FARO_APP_NAME: "transmission",
            REACT_APP_FARO_SAMPLE_RATE: "1",
            REACT_APP_OCELOTLINK : "https://staging.ocelotlinks.com/"
        };
    } else if (window.location.host.includes('transmission.ocelotlinks.com')) {
        return {
            REACT_APP_CENTRAL_AUTH: "https://central-auth.ocelotlinks.com",
            REACT_APP_REST_API: "https://api.ocelotlinks.com",
            REACT_APP_KEYCLOAK_URL: "https://sso.ocelotlinks.com",
            REACT_APP_KEYCLOAK_REALM: "OcelotLinks",
            REACT_APP_KEYCLOAK_CLIENTID: "myclient",
            REACT_APP_ENVIRONMENT : "production",
            REACT_APP_FARO_URL: "https://faro.ocelotlinks.com/collect",
            REACT_APP_FARO_APP_NAME: "transmission",
            REACT_APP_FARO_SAMPLE_RATE: "0.3",
            REACT_APP_OCELOTLINK : "https://ocelotlinks.com/"
        };
    } else {
        throw new Error("Unsupported hostname");
    }
};

export const ENV = getEnvironmentVariables();
